export const ASYNC_SUFFIXES: [string, string, string] = ['STARTED', 'SUCCEEDED', 'FAILED'];
export const ASYNC_SUFFIX_DELIMITER = '_';
